module.exports = __webpack_public_path__ + "media/images/icons/chevron_right-c2d9dd067fd1905a5f3c1b443256963c.svg";